import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import EventTypes from "../shared/EventTypes";

export default class Menu extends AbstractProvidedClass {
    config = {
        'select': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg?v=491#cursor-fill"></use></svg>',
            'tooltip': 'Select (C)',
            'callback': () => this.tools.setTool('select'),
        },
        'shapes': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg?v=491#shape-line"></use></svg>',
            'tooltip': 'Shapes (A)',
            'callback': () => this.tools.setTool('shapes'),
        },
        'navigation': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg?v=491#drag-move-2-fill"></use></svg>',
            'tooltip': 'Navigate (N)',
            'callback': () => this.tools.setTool('navigate'),
        },
        'erase': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg?v=491#eraser-line"></use></svg>',
            'tooltip': 'Eraser (E)',
            'callback': () => this.tools.setTool('erase'),
        },
        'image': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg?v=491#image-2-line"></use></svg>',
            'tooltip': 'Image (SHIFT + I)',
            'callback': () => this.tools.setTool('image'),
        },
        'settings': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg?v=491#settings-3-line"></use></svg>',
            'tooltip': 'Settings (,)',
            'callback': () => this.tools.setTool('settings'),
        },
        'help': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg?v=491#question-line"></use></svg>',
            'tooltip': 'Help (H)',
            'callback': () => this.tools.setTool('help'),
        },
        'reset': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg?v=491#refresh-line"></use></svg>',
            'tooltip': 'Reset view (SHIFT+R)',
            'callback': () => this.view.reset(),
        },
        'save': {
            'icon': 'Save',
            'tooltip': 'Save (CTRL+S)',
            'callback': () => this.dataHandler.savePlan(),
        },
        'undo': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg?v=491#arrow-go-back-fill"></use></svg>',
            'tooltip': 'Undo (CTRL+Z)',
            'callback': () => this.actions.undo(),
        },
        'redo': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg?v=491#arrow-go-forward-fill"></use></svg>',
            'tooltip': 'Redo (CTRL+Y)',
            'callback': () => this.actions.redo(),
        },
    };

    init(leftButtons, rightButtons) {
        this.container = this.p.createDiv()
            .parent('#p5canvas')
            .class("planner-toolbar planner-ui-overlay")
            .style('z-index', 2);

        this.leftButtons = leftButtons.map((button) => this.createMenuButton(button));
        this.rightButtons = rightButtons.map((button) => this.createMenuButton(button));

        this.on(EventTypes.OPEN_SIDEBAR, () => this.hide());
        this.on(EventTypes.CLOSE_SIDEBAR, () => this.show());
    }

    createMenuButton(name) {
        let config = this.config[name];
        let buttonName = `${name}Button`;
        let button = this.p.createButton(config['icon'])
            .parent(this.container)
            .class('btn-icon-clear -u-tt-bottom')
            .mousePressed(config['callback']);

        // Save is the one action new users come looking for, so render it as a
        // clearly-labelled, prominent pill instead of a cramped icon-sized box.
        if (name === 'save') {
            button.addClass('planner-save-btn');
        }

        if (!this.touch) {
            button.attribute('data-tooltip', config['tooltip']);
        }
        if (['undo', 'redo'].includes(name)) {
            button.attribute('disabled', 'true');
        }
        window[buttonName] = button;
        return button;
    }

    setCurrentToolIcon(_html) {}

    resetCurrentToolIcon() {}

    showNewPlanSaveButton() {}

    showMultiSelectButton(_onToggle) {}

    hideMultiSelectButton() {}

    hide() {
        if (this.container.elt.offsetWidth + this.sideBar.width + this.sideBar.labelWidth + 20 > this.p.width) {
            this.container.hide();
        }
    }

    show() {
        this.container.show();
        this.container.style('display', null);
    }
}
